module.exports = __webpack_public_path__ + "img/48000.5d687b26.jpg";